import { ErrorBoundary, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import {
  SentOrdersCardResponseNormalized,
  sentOrdersCardsQuery,
} from '../../../../store/rateManagement/selector';

import { Card } from './components/Card';

export namespace HeaderCardsTypes {
  export interface Props {
    carousel?: boolean;
  }
}

export const HeaderCards: React.FC<HeaderCardsTypes.Props> = ({ carousel }) => {
  const { data, loading, error, refresher } = useRecoilQuery(sentOrdersCardsQuery);
  const loadingData = [undefined, undefined, undefined] as any;

  if (error) {
    return <ErrorBoundary onRefresh={refresher} />;
  }

  if (carousel) {
    const renderItem = ({
      item,
      index,
    }: {
      item: SentOrdersCardResponseNormalized;
      index: number;
    }) => (
      <Box
        paddingLeft={index === 0 ? Spacing['inset.xs'] : 0}
        paddingRight={
          index === (loading ? loadingData : data).length - 1 ? 0 : Spacing['inset.xs']
        }>
        <Card loading={loading} item={item} />
      </Box>
    );

    return (
      <FlatList
        style={{ width: '100%' }}
        horizontal
        pagingEnabled
        data={loading ? loadingData : data}
        renderItem={renderItem}
        keyExtractor={(_, index) => index.toString()}
        showsHorizontalScrollIndicator={false}
      />
    );
  }

  return (
    <HStack mt={Spacing['inset.sm']} justifyContent={'space-between'}>
      {loading ? (
        <>
          <Card loading />
          <Card loading />
          <Card loading />
        </>
      ) : (
        data?.map((item, index) => <Card item={item} key={index.toString()} />)
      )}
    </HStack>
  );
};
